import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { useTranslation } from 'react-i18next';

import { useSearchParams } from 'react-router-dom'
import HtmlToReact from 'html-to-react';

import '../assets/css/privacy.scss'


const Privacy = (props) => {
    const Parser = HtmlToReact.Parser();
    const { t } = useTranslation();
    const { lang } = props;
    const [searchParams] = useSearchParams();
    const [mode, setMode] = useState('')
    const [logo, setLogo] = useState('')
    const [isLogo, setIsLogo] = useState(false);
    useEffect(() => {
        i18next.changeLanguage(lang);
        setMode(searchParams.get("mode"));
        setIsLogo(!searchParams.get("nologo"));
    },[lang])

    useEffect(() => {
        if(!isLogo)  setLogo(`logo${mode ? mode : ''}.jpg`)

    }, [mode, isLogo])

    return (
        <div className={`container_${mode}`}>
            <div className="wrapper">
                {isLogo ? 
                <div className="classlogo">
                    <img src={`/assets/img/${logo}`} alt="Crèdit assegurances vida" />
                </div>
                : ''}
                <h1>{t('TITLE')}</h1>
                {/* <!-- I.- --> */}
                <div className="texts">
                    <h2>{t('T1')}</h2>
                    <h3>{t('T1S1')}</h3>
                    <ul>
                        <li>{t('T1S1U1U1L1')}</li>
                        <li>{t('T1S1U1U1L2')}</li>
                    </ul>
                </div>                
                {/* <!-- II --> */}
                <div className="texts">
                    <h2>{t('T2')}</h2>
                    <p>{t('T2P1')}</p>
                    <p>{t('T2P2')}</p>
                    <ul>
                        <li>{t('T2U1L1')}</li>
                        <li>{t('T2U1L2')}</li>
                        <li>{t('T2U1L3')}</li>
                        <li>{t('T2U1L4')}</li>
                    </ul>
                    <p>{t('T2P3')}</p>
                </div>
                {/* <!-- III --> */}
                <div className="texts">
                    <h2>{t('T3')}</h2>
                    <h3>{t('T3S1')}</h3>
                    <p>{t('T3S1P1')}</p>
                </div>
                {/* <!-- IV --> */}
                <div className="texts">
                    <h2>{t('T4')}</h2>
                    <p><span>{Parser.parse(t('T4P1'))}</span></p>
                </div>
                {/* <!-- V --> */}
                <div className="texts">
                    <h2>{t('T5')}</h2>
                    <p>{t('T5P1')}</p>
                </div>
                {/* <!-- VI --> */}
                <div className="texts">
                    <h2>{t('T6')}</h2>
                    <p>{t('T6P1')}</p>
                </div>
                {/* <!-- VII --> */}
                <div className="texts">
                    <h2>{t('T7')}</h2>
                    <p><span>{Parser.parse(t('T7P1'))}</span></p>
                    <p><i><span>{Parser.parse(t('T7P2'))}</span></i></p>
                </div>
            </div>
        </div>
    )
}

export default Privacy;